// modules
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { addModal } from 'weblite-web-modal-viewer'
// component
import { ChangelogModal } from './changelog-modal'

const COMPONENT_ID = 'changelog'

export const showChangelogModal = () => addModal({ id: COMPONENT_ID })

export default {
  [COMPONENT_ID]: {
    Component: ChangelogModal,
  },
}
